define('modules/resolution/models/concord.individual.model',[
    'underscore',
    'backbone',
    'modules/base/models/base.model'
], function(_, Backbone, BaseModel){
    var ConcordIndividualModel  = BaseModel.extend({
        base: 'concordance/individuals',
        // baseService: 'doli/v1',
    });
    return ConcordIndividualModel;
});

